import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import BrushDisabled from "../../../../../../../../../../../../Assets/Icons/AI_Studio/Brush/brush-disabled.svg";
import Brush from "../../../../../../../../../../../../Assets/Icons/AI_Studio/Brush/brush.svg";
import Brush_1 from "../../../../../../../../../../../../Assets/Icons/AI_Studio/Brush/brush-1.svg";
import Brush_2 from "../../../../../../../../../../../../Assets/Icons/AI_Studio/Brush/brush-2.svg";
import Brush_3 from "../../../../../../../../../../../../Assets/Icons/AI_Studio/Brush/brush-3.svg";
import Undo from "../../../../../../../../../../../../Assets/Icons/undo.svg";
import UndoEnabled from "../../../../../../../../../../../../Assets/Icons/undoEnabled.svg";
import { useAIToolsContext } from "../../../../../../../../context/AIToolsProvider";
import {
  canvasBrushSize,
  CanvasBrushSizeOptions,
} from "../../../../../../../../constant";
import { styled } from "@mui/material/styles";
import { useADSContext } from "../../../../../../../../context/ADSProvider";

const MapValueRender = {
  [canvasBrushSize.small]: Brush,
  [canvasBrushSize.medium]: Brush_1,
  [canvasBrushSize.large]: Brush_2,
  [canvasBrushSize.XLarge]: Brush_3,
};

const Wrapper = styled("div")({
  height: 40,
  width: 560,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
});

const CustomSelect = styled(Select)({
  "& .MuiSelect-select": {
    padding: "0px", // Remove padding inside the select
    overflow: "visible", // Ensure no ellipsis
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none", // Remove border
  },
  "& .MuiSvgIcon-root": {
    color: "#FB4764",
    marginTop: "5px",
    marginRight: "0",
  },
  minWidth: "40px",
  width: "40px",
  backgroundColor: "transparent",
});

const HighlightAndSwapActions = () => {
  const { selectedProduct } = useADSContext();
  const {
    canvasRef,
    brushSize,
    setBrushSize,
    canvasHasChanges,
    firstSelectedImage,
  } = useAIToolsContext();

  const imagePath =
    selectedProduct?.imageEditedUrl || selectedProduct?.imageUrl || null;

  const renderBrush = imagePath || firstSelectedImage;

  const handleUndo = () => {
    if (canvasRef.current) {
      canvasRef.current.undo();
    }
  };

  return (
    <Wrapper>
      {/*BRUSH SELECTOR*/}
      <FormControl>
        <CustomSelect
          variant="outlined"
          value={brushSize}
          onChange={(e) => setBrushSize(e.target.value)}
          disabled={!renderBrush}
          renderValue={() => (
            <img
              src={renderBrush ? MapValueRender[brushSize] : BrushDisabled}
              alt="brush-size"
            />
          )}
        >
          {CanvasBrushSizeOptions.map((canvasBrushSize) => (
            <MenuItem value={canvasBrushSize.value} key={canvasBrushSize.value}>
              <img src={canvasBrushSize.label} alt="brush" />
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>

      {/*UNDO*/}
      <img
        src={canvasHasChanges ? UndoEnabled : Undo}
        alt="undo"
        style={{ cursor: "pointer" }}
        onClick={handleUndo}
      />

      {/*Description*/}
      <span
        style={{
          fontWeight: "500",
          fontSize: "14",
          color: "#646666",
        }}
      >
        Highlight an area on the image and push the ‘Generate’ button
      </span>
    </Wrapper>
  );
};

export default HighlightAndSwapActions;
